import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { FONT_ENUM } from '../../../types/global/fonts.types';

export function CampaignThreadTypingBar({
    label,
    accentColor,
    mutedColor,
    align = 'flex-start',
}: {
    label: string;
    accentColor: string;
    mutedColor: string;
    align?: 'flex-start' | 'flex-end';
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 1.25,
                py: 0.75,
                alignSelf: align,
            }}>
            <CircularProgress size={12} thickness={5} sx={{ color: accentColor, flexShrink: 0 }} />
            <Typography
                sx={{
                    fontSize: 12,
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    color: mutedColor,
                    fontStyle: 'italic',
                }}>
                {label}
            </Typography>
        </Box>
    );
}
